import * as TYPES from './mutations-types'

export default {
  [TYPES.SET_THEMATICPAGES_LIST] (state, loadedList) {
    state.thematicPagesList = loadedList
  }
}
